module.exports = "/_next/static/images/thumbnail-2f2d0f72869f233e8632fa6a841d3a4d.webp";